export default "__VITE_ASSET__74d1d008__"